var render, staticRenderFns
import script from "./FormModule.vue?vue&type=script&lang=js&"
export * from "./FormModule.vue?vue&type=script&lang=js&"
import style0 from "./FormModule.vue?vue&type=style&index=0&id=c2b8d444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8d444",
  null
  
)

export default component.exports